export enum EStav {
    AKCEPTOVANO = 'akceptovano',
    ZAMITNUTO = 'zamitnuto',
    KDOPLNENI = 'kdoplneni',
    KODESLANI = 'kodeslani',
    DOPLNENO = 'doplneno',
    ODESLANO = 'odeslano',
    AKTUALIZOVAT = 'aktualizovat',
    ROZPRACOVANO = 'rozpracovano',
    ZRUSENO = 'zruseno',
    ZNEPLATNENO = 'zneplatneno'
}
